import FromPlanificaciones from '../componentes/FormPlanificaciones.vue'
import ListaPlanificaciones from '../componentes/ListaPlanificaciones.vue'


const routes = [
    ...route('/guardar-planificacion', FromPlanificaciones, {
        Auth: true,
        ///req_admin: true
     }),
     ...route('/ver-planificacion', ListaPlanificaciones, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes